import * as React from "react";
function PhoneCheckmarkIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "50px"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.25 15.75v4.768a1.98 1.98 0 0 1-1.982 1.982H5.732a1.98 1.98 0 0 1-1.983-1.981V4.983A1.985 1.985 0 0 1 5.733 3H7.5a.75.75 0 0 0 0-1.5H5.733A3.483 3.483 0 0 0 2.25 4.983v15.536A3.48 3.48 0 0 0 5.733 24h6.535a3.48 3.48 0 0 0 3.482-3.482V15.75a.75.75 0 0 0-1.5 0M3 19.5h12a.75.75 0 0 0 0-1.5H3a.75.75 0 0 0 0 1.5M20.25 6.75a5.25 5.25 0 1 1-10.5 0 5.25 5.25 0 0 1 10.5 0m1.5 0a6.75 6.75 0 1 0-13.5 0 6.75 6.75 0 0 0 13.5 0m-4.676-2.194-2.9 3.873h-.002l-1.499-1.5a.75.75 0 1 0-1.06 1.061l1.5 1.5a1.502 1.502 0 0 0 2.26-.16l2.901-3.874a.75.75 0 0 0-1.2-.9"
  }));
}
export default PhoneCheckmarkIcon;